// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { Container, Header, Icon, Popup, Table } from "semantic-ui-react";
import { ApplicationNavigationContext } from "../ApplicationNavigation";
import { ApplicationPageContext } from "../ApplicationPage";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ApplicationHelpModule = () => {
  const {
    module
  } = React.useContext(ApplicationNavigationContext);
  const {
    manifest,
    loading
  } = React.useContext(ApplicationPageContext);
  const dependencies = React.useMemo(() => /*#__PURE__*/_jsxs(Table, {
    className: "scrolling",
    compact: true,
    style: {
      width: "440px"
    },
    children: [/*#__PURE__*/_jsx(Table.Header, {
      children: /*#__PURE__*/_jsxs(Table.Row, {
        children: [/*#__PURE__*/_jsx(Table.HeaderCell, {
          width: 11,
          children: "Nom"
        }), /*#__PURE__*/_jsx(Table.HeaderCell, {
          width: 5,
          textAlign: "right",
          children: "Version"
        })]
      })
    }), /*#__PURE__*/_jsx(Table.Body, {
      children: _.map(manifest?.dependencies, (version, name) => /*#__PURE__*/_jsxs(Table.Row, {
        children: [/*#__PURE__*/_jsx(Table.Cell, {
          width: 11,
          children: name
        }), /*#__PURE__*/_jsx(Table.Cell, {
          width: 5,
          textAlign: "right",
          children: version
        })]
      }, `${name}-${version}`))
    })]
  }), [manifest?.dependencies]);
  const header = React.useMemo(() => manifest?.version && /*#__PURE__*/_jsx(Container, {
    fluid: true,
    children: /*#__PURE__*/_jsx(Popup, {
      position: "top right",
      on: "click",
      trigger: /*#__PURE__*/_jsxs(Header, {
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "sitemap"
        }), /*#__PURE__*/_jsxs(Header.Content, {
          children: [`${module?.libelle} ${manifest?.version}`, /*#__PURE__*/_jsx(Header.Subheader, {
            children: `${new Date(manifest?.date).toLocaleString()} (${manifest?.revision})`
          })]
        })]
      }),
      children: dependencies
    })
  }), [manifest?.date, manifest?.version, manifest?.revision, module?.libelle, dependencies]);
  return React.useMemo(() => /*#__PURE__*/_jsx(Container, {
    className: "module",
    children: !loading && header
  }), [header, loading]);
};